<template>
  <fragment>
    <mc-app-header title="Edit Concept">
      <template #right>
        <fragment v-show="concepts.selected.id === $route.params.id">
          <div class="level-item">
            <b-switch
              v-model="concepts.selected.hidden"
              @input="updateConceptVisibilityHandler"
            >
              {{ concepts.selected.hidden ? 'Hidden' : 'Visible' }}
            </b-switch>
          </div>
          <div class="level-item">
            <b-dropdown
              :disabled="concepts.publishing"
              position="is-bottom-left"
            >
              <button slot="trigger" class="button is-primary">
                <span>Publish</span>
                <b-icon icon="menu-down" />
              </button>

              <b-dropdown-item @click="publishConceptHandler('admin')">
                <div class="media">
                  <div class="media-content">
                    <div class="title is-6">Admin Version</div>
                    <div class="content is-small">
                      The concept will published only for admins, user's with
                      testing access will be able to test this concept.
                    </div>
                  </div>
                </div>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="concepts.selected.publishedToAdmin"
                @click="publishConceptHandler('minor')"
              >
                <div class="media">
                  <div class="media-content">
                    <div class="title is-6">Minor Version</div>
                    <div class="content is-small">
                      Only new concept attempts will be created from this
                      version.
                    </div>
                  </div>
                </div>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="concepts.selected.publishedToAdmin"
                @click="publishConceptHandler('major')"
              >
                <div class="media">
                  <div class="media-content">
                    <div class="title is-6">Major Version</div>
                    <div class="content is-small">
                      Older concept attempts will also be able to upgrade to
                      this version.
                    </div>
                  </div>
                </div>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </fragment>
      </template>
    </mc-app-header>
    <mc-app-body :submitting="concepts.submitting || concepts.publishing">
      <div class="edit-concept section">
        <b-loading
          v-if="concepts.loadingSelected"
          active
          :is-full-page="false"
        />
        <mc-error-layout
          v-else-if="concepts.selectError"
          message="Failed to load concept!"
          :retry-fn="() => selectConcept($route.params.id)"
        />
        <div v-else>
          <form
            class="edit-concept__form mc-container"
            @submit.prevent="updateConceptHandler"
          >
            <b-field grouped>
              <b-field label="Topic" expanded>
                <mc-topic-select v-model="concepts.selected.topic" disabled />
              </b-field>
              <b-field label="Level" expanded>
                <b-input
                  v-model="concepts.selected.level"
                  placeholder="Level"
                  type="text"
                />
              </b-field>
            </b-field>
            <b-field label="Name">
              <b-input
                v-model="concepts.selected.name"
                icon="format-title"
                placeholder="Name"
                type="text"
              />
            </b-field>
            <b-field label="Poster">
              <mc-image-input
                v-model="concepts.selected.poster"
                icon="image"
                placeholder="Poster Link"
                type="POSTER"
              />
            </b-field>
          </form>
          <step-editor />
        </div>
      </div>
    </mc-app-body>
    <question-editor />
  </fragment>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import QuestionEditor from '../../ui/QuestionEditor';
import StepEditor from './StepEditor';

export default {
  computed: {
    ...mapState(['concepts'])
  },
  methods: {
    ...mapActions('concepts', [
      'publishConcept',
      'selectConcept',
      'updateConcept'
    ]),
    parsePublishError(error) {
      switch (error.message) {
        case 'has_no_steps':
          return 'Concept should have atleast one step!';
        case 'invalid_step_data':
          return `
        All videos should have a video link and tests should have atleast
        one question`;
        default:
          return 'Failed to publish concept';
      }
    },
    publishConceptHandler(type) {
      this.$buefy.dialog.confirm({
        message: `
        Proceeding will ${
          type == 'admin' ? 'save' : 'discard'
        } your unsaved changes and publish a new '${type}' version of
        this concept.`,
        confirmText: 'Publish Concept',
        onConfirm: async () => {
          try {
            if (type == 'admin') {
              await this.updateConcept({ ...this.concepts.selected });
            }
            await this.publishConcept({ type });
            this.selectConcept(this.concepts.selected.id);
            this.$buefy.toast.open(
              `A new '${type}' version of the concept has been published!`
            );
          } catch (error) {
            this.$buefy.toast.open({
              message: this.parsePublishError(error),
              type: 'is-danger'
            });
          }
        }
      });
    },
    async updateConceptHandler() {
      try {
        await this.updateConcept({ ...this.concepts.selected });
        this.selectConcept(this.concepts.selected.id);
        this.$buefy.toast.open({
          message: 'Concept updated successfully!',
          type: 'is-success'
        });
      } catch (error) {
        this.$buefy.toast.open({
          message: 'Failed to update concept!',
          type: 'is-danger'
        });
      }
    },
    async updateConceptVisibilityHandler() {
      try {
        await this.updateConcept({
          hidden: this.concepts.selected.hidden,
          id: this.concepts.selected.id
        });
        this.selectConcept(this.concepts.selected.id);
        this.$buefy.toast.open({
          message: 'Concept Visibility updated successfully!',
          type: 'is-success'
        });
      } catch (error) {
        this.$buefy.toast.open({
          message: 'Failed to update concept visibility!',
          type: 'is-danger'
        });
      }
    }
  },
  created() {
    this.selectConcept(this.$route.params.id);
  },
  components: {
    QuestionEditor,
    StepEditor
  }
};
</script>

<style lang="scss" scoped>
.media-content {
  white-space: normal;
}

.edit-concept {
  &__form {
    margin-bottom: 2rem;
    &__switch {
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
